(ns manatee.admin.app-db
  #?(:cljs (:require [cljs-time.coerce :as tc]))
  #?(:cljs (:require [cljs-time.format :as tf])))

(def root-path [:admin])
(def users-path (conj root-path :users))
(def adding-user-path (conj root-path :adding-user))
(def user-teams-path (conj root-path :user-teams))
(def team-filter-path (conj root-path :team-filter))
(def task-summary-path (conj root-path :task-summary))
(def selected-tab-path (conj root-path :selected-tab))
(def messages-path (conj root-path :messages))
(def user-guide-payload-path (conj root-path :user-guide-payload))

(defn move-flag
  [db path flag id]
  (letfn [(toggle-match [entity x]
            (when (= id (:id entity)) (not x)))]
    (update-in db path
               (fn [entity]
                 (mapv #(update % flag (partial toggle-match %))
                       entity)))))

(defn get-users
  [db]
  (->> (get-in db users-path)
       (filter #(or (:first-name %) (:last-name %) (:email %)))))

(defn get-user
  [db user-id]
  (first (filter #(= (:id %)
                     user-id)
                 (get-in db users-path))))

(defn set-user-updating?
  [db user-id updating?]
  (update-in db users-path (fn [users]
                             (mapv (fn [{:keys [id] :as u}]
                                     (cond-> u
                                       (= id user-id) (assoc :updating? updating?)))
                                   users))))

(defn get-adding-user?
  [db]
  (get-in db adding-user-path))

(defn set-adding-user?
  [db adding?]
  (assoc-in db adding-user-path adding?))

(defn get-user-teams
  [db]
  (->> (get-in db user-teams-path)))

(defn get-team-filter
  [db]
  (get-in db team-filter-path))

(defn set-users
  [db users]
  (assoc-in db users-path users))

(defn set-user-teams
  [db user-teams]
  (assoc-in db user-teams-path user-teams))

(defn set-team-filter
  [db filter]
  (assoc-in db team-filter-path filter))

(defn set-selected-user
  [db user-id]
  (move-flag db users-path :selected? user-id))

(defn selected-tab
  [db]
  (get-in db selected-tab-path))

(defn set-selected-tab
  [db tab]
  (assoc-in db selected-tab-path tab))

(defn get-messages
  [db]
  (get-in db messages-path))

(defn set-messages
  [db messages]
  (assoc-in db messages-path messages))

(defn set-selected-message
  [db message-id]
  (move-flag db messages-path :selected? message-id))

(defn toggle-message-mark
  [db message-id]
  (move-flag db messages-path :marked? message-id))

(defn get-marked-message
  [db]
  (->> (get-in db messages-path)
       (filter :marked?)
       (first)))

#?(:cljs (def ^:private formatter (tf/formatter "HH:mm dd/MMM/yyyy")))

#?(:cljs (defn format-editable-time
           "Takes DateTime, returns user-friendly string."
           [ts]
           (tf/unparse formatter ts)))

#?(:cljs (defn parse-editable-time
           "Takes user-friendly string, returns DateTime"
           [ts]
           (try (tf/parse formatter ts)
                (catch :default _))))

#?(:cljs (defn format-api-timestamp
           [ts]
           (-> ts (tc/to-long) (js/Date.))))

(defn get-task-summary
  [db]
  (get-in db task-summary-path))

(defn set-task-summary
  [db summary]
  (assoc-in db task-summary-path summary))

(defn get-user-guide-payload
  [db]
  (get-in db user-guide-payload-path))

(defn set-user-guide-payload
  [db file]
  (assoc-in db user-guide-payload-path file))
